export class RegistrationUnit {

  public id: string;
  public registrationId: string;
  public institutionId: string;
  public unitId: string;
  public name: string;
}
